import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/lib/content";
import Tilt from "@/components/site/Tilt";

export default function Testimonials() {
  return (
    <section
      id="stimmen"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 bg-slate-950 text-white overflow-hidden"
      style={{ perspective: "1200px" }}
    >
      {/* subtle background pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,rgba(2,132,199,0.25),transparent_55%),radial-gradient(circle_at_80%_70%,rgba(14,165,233,0.15),transparent_55%)]" />
      <div className="absolute inset-0 noise-overlay" />

      <div className="relative mx-auto max-w-7xl px-6 md:px-10 lg:px-12">
        <div className="max-w-2xl mb-14 md:mb-20">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-sky-300">
            <span className="w-6 h-px bg-sky-400" /> Social Proof
          </span>
          <h2 className="font-display mt-4 text-4xl sm:text-5xl font-semibold leading-[1.05]">
            Was unsere Kunden sagen.
          </h2>
          <p className="mt-5 text-slate-300 text-base md:text-lg leading-relaxed">
            Saubere Ergebnisse und klare Kommunikation — deshalb empfehlen uns
            unsere Kunden immer wieder weiter.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: 0.08 * i }}
            >
              <Tilt max={8} scale={1.015} glare>
                <figure
                  data-testid={`testimonial-${i}`}
                  className="relative rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur p-7 hover:border-sky-400/30 hover:bg-white/[0.06] transition-all shadow-[0_20px_50px_-20px_rgba(2,132,199,0.35)]"
                >
                  <Quote className="w-8 h-8 text-sky-400/70" style={{ transform: "translateZ(30px)" }} />
                  <div className="mt-5 flex gap-0.5" aria-label="5 von 5 Sternen">
                    {Array.from({ length: 5 }).map((_, k) => (
                      <Star key={k} className="w-4 h-4 fill-amber-300 text-amber-300" />
                    ))}
                  </div>
                  <blockquote className="mt-4 text-white/90 leading-relaxed text-[15px]" style={{ transform: "translateZ(20px)" }}>
                    „{t.text}"
                  </blockquote>
                  <figcaption className="mt-6 pt-5 border-t border-white/10">
                    <div className="font-display font-semibold text-white">{t.name}</div>
                    <div className="text-sm text-slate-400">{t.role}</div>
                  </figcaption>
                </figure>
              </Tilt>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
